@if(visitCardStatus) {
    <div class="VisitCardImage">
        @if(!noImage && visitCardStatus.status == 'confirmed') {
            <div class="VisitCardImage-ImageContainer">
                @if(cardImage == null) {
                    <app-pg-loading></app-pg-loading>
                }
                <canvas #cardCanvasElement [hidden]="cardImage == null"></canvas>
            </div>
        }
        @else {
            <div class="p-3">
                <div class="d-flex mb-1">
                    <div>
                        <i class="fa-regular fa-qrcode fa-fw me-2"></i>
                        <span class="me-2">{{ 'visit-card-image.visit-card-code' | locTranslate }}:</span>
                    </div>
                    <div>
                        <b>{{visitCardStatus.code}}</b>
                    </div>
                </div>
            
                <div>
                    <span class="me-1">{{ 'visit-card-image.visit-card-from' | locTranslate }}</span>
                    <b>{{visitCardStatus.from | locFormat:'date'}}</b>
                    <span class="mx-1">{{ 'visit-card-image.visit-card-to' | locTranslate }}</span>
                    <b>{{visitCardStatus.to | locFormat:'date'}}</b>
                </div>
            
                @if(getVisitCardStatusDisplay(visitCardStatus.status); as display) {
                    <div class="VisitCardImage-Status mt-3 text-end">
                        <div class="badge bg-{{ display.color }}">
                            <i class="fa-regular {{ display.icon }}"></i>
                            <span>{{ 'visit-card-image.visit-card-status-' + visitCardStatus.status | locTranslate }}</span>
                        </div>
                    </div>
                }
            </div>
        }
    </div>
}